const commovisconfig = {
  region: 'eu-west-1',
  default_tenant: 'commovis',
  default_base_api: 'https://9xd35yw450.execute-api.eu-west-1.amazonaws.com',
  default_full_uri: 'https://commovis.dev.commovis.com',
  dev_stage_base_api: 'https://api.dev.commovis.com',
  dev_stage_URLbase_end: '.dev.commovis.com',
  prod_stage_URLbase_end: '.commovis.com',
  prod_stage_base_api: 'https://api.commovis.com',
  redirect_tenant_url: 'https://www.rupertseewald.com',
  default_imprint_url: 'https://www.rupertseewald.com/imprint',
  
  // Firebase Configuration for Web App
  firebase: {
    apiKey: "AIzaSyA2lgNJQnZX2bzjnqx38SAsMujFxmAOF9E",
    authDomain: "commovis.firebaseapp.com",
    projectId: "commovis",
    storageBucket: "commovis.firebasestorage.app",
    messagingSenderId: "559672599254",
    appId: "1:559672599254:web:2c86a4e745e5ae7c9a9f77"
  },
  
  // FCM VAPID Key for Web Push (keep your existing one for now)
  vapidPublicKey: 'BO15ZfWOSbjGxufOGQAwgziLsqEBSfYgEMsnYwqfVERB29vZ35K8uzlXh8o_qvAwDzvrbPB2tx9O5kk3_-8BpGs'
}

module.exports = commovisconfig;
